export enum TimeInMilliseconds {
  OneMinute = 60 * 1000,
}

export enum TimeInSeconds {
  OneHour = 60 * 60,
  OneDay = 24 * 60 * 60,
}
